import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from 'react-scroll-parallax';
import AppearingElement from "../Helper/AppearingElement";
import './main.css';

// Landing Pages Section 2A
function MountainInfoSection(props) {
    return (
        <section className="mountain-info-section-pendo">
            <div className="mountain-info-section__content-pendo">
                {!props.hideParallax &&
                    <Parallax y={[-20, 5]}>
                        <AppearingElement variant="fade-in">
                            <Typography variant="h6">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    </Parallax>
                }
                {props.hideParallax &&
                    <AppearingElement variant="zoom-down">
                        <Typography variant="h6">
                            {props.content}
                        </Typography>
                    </AppearingElement>
                }
            </div>
            {!props.hideParallax &&
                <Parallax y={[42.5, 12.5]} className="mountain-info-section__media-pendo">
                    <AppearingElement variant="fade-in" threshold="0.2">
                        <video src={props.media} autoPlay loop muted playsInline>
                            Sorry, your browser doesn't support embedded videos.
                    </video>
                    </AppearingElement>
                </Parallax>
            }
            {props.hideParallax &&
                <video src={props.media} className="mountain-info-section__media-pendo" autoPlay loop muted playsInline>
                    Sorry, your browser doesn't support embedded videos.
            </video>
            }
        </section>
    );
}

export default MountainInfoSection;